import { STATUS_META } from "@/lib/constants";

export const StatusBadge = ({ status, className = "" }) => {
  const meta = STATUS_META[status] || { label: status, color: "148 8% 40%", bg: "44 15% 88%" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${className}`}
      style={{ backgroundColor: `hsl(${meta.bg})`, color: `hsl(${meta.color})` }}
    >
      <span className="status-dot" style={{ backgroundColor: `hsl(${meta.color})` }} />
      {meta.label}
    </span>
  );
};
